import { render } from "./WithoutHeaderFooter.vue?vue&type=template&id=08bad580"
import script from "./WithoutHeaderFooter.vue?vue&type=script&lang=js"
export * from "./WithoutHeaderFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__